import AuthGateway from '../../../../shared_components/AuthGateway'

const OrganizationAdmin = props => (
  <AuthGateway needsAccountManager={true} needsFirmUser={true}>
    {props.children}
  </AuthGateway>
)

export default OrganizationAdmin
